import axiosInstance from "../../api/axiosInstance";
import { dictionary } from "../../api";

const apiUrl = dictionary;

export function loadDictionary(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/dictionary/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadDictionaryById(id) {
  return axiosInstance.get(`${apiUrl}/dictionary/details/${id}`);
}

export function updateDictionary(id, data) {
  return axiosInstance.put(`${apiUrl}/dictionary/details/${id}`, data);
}

export function loadAllDictionary() {
  return axiosInstance.get(`${apiUrl}/dictionary/list`);
}

export function loadDictionaryData(pageLimit, page, search, id) {
  return axiosInstance.get(
    `${apiUrl}/dictionary/item/parent?limit=${pageLimit}&offset=${page}&dictionary__id=${id}&search=${search}`
  );
}

export function loadDictionaryItem(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/dictionary/item/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addDictionary(data) {
  return axiosInstance.post(`${apiUrl}/dictionary`, data);
}

export function addDictionaryItem(data) {
  return axiosInstance.post(`${apiUrl}/dictionary/item`, data);
}

export function loadDictionaryItemById(id) {
  return axiosInstance.get(`${apiUrl}/dictionary/item/details/${id}`);
}

export function saveDictionaryItemChanges(id, data) {
  return axiosInstance.put(`${apiUrl}/dictionary/item/details/${id}`, data);
}

export function loadDictionaryItemValidation(name) {
  return axiosInstance.get(
    `${apiUrl}/dictionary/item/check?dictionary_item_name__in=${name}`
  );
}
